<template>
  <link rel="stylesheet" :href="`https://fonts.googleapis.com/css?family=${url}`" v-if="url">
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'font-loader',
    computed: {
      ...mapState('builder', ['templates', 'currentTemplate']),
      url () {
        const { font } = this.templates[this.currentTemplate]

        return font && font.url
      }
    }
  }
</script>
